import { supabase } from "@/integrations/supabase/client";

// Map related_table → { table to query, public route builder, admin fallback }.
// slugField=null means the identifier can be used directly (e.g. shared route).
const ENTITY_ROUTING: Record<string, {
  table?: string;
  slugField?: string | null;
  publicRoute: (idOrSlug: string) => string;
  adminFallback?: string;
}> = {
  listings:            { table: "listings",                 slugField: "slug", publicRoute: (s) => `/listing/${s}`,        adminFallback: "/admin/listings" },
  articles:            { table: "articles",                 slugField: "slug", publicRoute: (s) => `/article/${s}`,        adminFallback: "/admin" },
  events:              {                                    slugField: null,   publicRoute: (id) => `/event/${id}`,        adminFallback: "/admin/events" },
  trainer_profiles:    { table: "trainer_profiles",         slugField: "slug", publicRoute: (s) => `/trainer/${s}`,        adminFallback: "/admin/trainers" },
  nutritionist_profiles:  { table: "nutritionist_profiles", slugField: "slug", publicRoute: (s) => `/nutricionista/${s}`,  adminFallback: "/admin" },
  physiotherapist_profiles:{ table: "physiotherapist_profiles", slugField: "slug", publicRoute: (s) => `/fisioterapeuta/${s}`, adminFallback: "/admin" },
  business_profiles:   { table: "business_profiles",        slugField: "slug", publicRoute: (s) => `/business/${s}`,       adminFallback: "/admin/businesses" },
  videos:              { table: "videos",                   slugField: "slug", publicRoute: (s) => `/video/${s}`,          adminFallback: "/admin/videos" },
  tribus:              { table: "tribus",                   slugField: "slug", publicRoute: (s) => `/tribu/${s}`,          adminFallback: "/admin" },
  desafios:            { table: "desafios",                 slugField: "slug", publicRoute: (s) => `/desafio/${s}`,        adminFallback: "/admin" },
  bookings:            {                                                       publicRoute: () => "",                       adminFallback: "/admin/bookings" },
  billing_records:     {                                                       publicRoute: () => "",                       adminFallback: "/admin/billing" },
  reviews:             {                                                       publicRoute: () => "",                       adminFallback: "/admin" },
  booking_system_leads:{                                                       publicRoute: () => "",                       adminFallback: "/admin/booking-leads" },
  affiliate_profiles:  {                                                       publicRoute: () => "",                       adminFallback: "/admin/affiliates" },
  users:               {                                                       publicRoute: (id) => `/admin/users/${id}`,   adminFallback: "/admin/users" },
  profiles:            {                                                       publicRoute: (id) => `/admin/users/${id}`,   adminFallback: "/admin/users" },
};

export function hasRoutingFor(relatedTable: string | null | undefined): boolean {
  return !!relatedTable && !!ENTITY_ROUTING[relatedTable];
}

export function getAdminFallback(relatedTable: string | null | undefined): string | null {
  if (!relatedTable) return null;
  return ENTITY_ROUTING[relatedTable]?.adminFallback ?? null;
}

export async function resolveNavigationTarget(
  relatedTable: string | null | undefined,
  relatedId: string | null | undefined
): Promise<string | null> {
  if (!relatedTable || !relatedId) return null;
  const cfg = ENTITY_ROUTING[relatedTable];
  if (!cfg) return null;
  if (cfg.slugField === null) return cfg.publicRoute(relatedId);
  if (!cfg.table || !cfg.slugField) return cfg.adminFallback || null;
  try {
    const { data } = await supabase
      .from(cfg.table as any)
      .select(cfg.slugField)
      .eq("id", relatedId)
      .maybeSingle();
    const slug = (data as any)?.[cfg.slugField];
    if (slug) return cfg.publicRoute(slug);
  } catch { /* ignore */ }
  return cfg.adminFallback || null;
}
